import React from "react";
import { ReactSVG } from "react-svg";

import Loading from "./Loading";

const Option = ({ 
  icon,
  title,
  description,
  loading,
  titleLoading,
  disabled,
  selected,
  error,
  onClick
}) => (
  <div className={`option-wrapper ${disabled ? "disabled" : ""} ${loading ? "loading" : ""}`}>
    <button
      className={`option ${selected ? "selected" : ""} ${loading ? "loading" : ""} ${error ? "error" : ""}`}
      type="submit"
      disabled={disabled}
      onClick={onClick}  
    >
      <div className="icon-wrapper">
        <ReactSVG className="icon" src={icon} />
        <Loading />
      </div>
      <span className="title">{loading ? titleLoading : title}</span>
      <span className="description">{description}</span>
    </button>
  </div>
);

export default Option;
